var _defs, _polyline, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.16 44.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6639b7;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.24 2.61 7.48 .05 91.68 0 97.82 2.57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,39.37c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.78,39.37c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.55,39.37c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.33,39.37c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.1,39.37c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.88,39.37c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.98,27.14c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.75,27.14c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.53,27.14c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.31,27.14c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.08,27.14c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.86,27.14c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.88,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.75,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.62,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.49,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.36,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.23,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.1,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.97,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.84,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.88,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.75,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.62,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.49,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.36,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.23,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.1,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.97,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.84,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.55,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.42,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.29,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.16,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.03,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.9,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.77,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.64,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.51,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.55,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.42,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.29,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.16,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.03,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.9,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.77,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.64,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.51,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.61,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.48,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.35,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.22,
    y: 22.25,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.61,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.48,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.35,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.22,
    y: 25.21,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.42,
    y: 37.62,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.29,
    y: 37.62,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.16,
    y: 37.62,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.03,
    y: 37.62,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.19,
    y: 37.62,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.06,
    y: 37.62,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.88,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.75,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.62,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.49,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.36,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.23,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.1,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.97,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.84,
    y: 13.29,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.42,
    y: 13.34,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.29,
    y: 13.34,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.16,
    y: 13.34,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.03,
    y: 13.34,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.98,15.3c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.75,15.3c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.53,15.3c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.31,15.3c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.08,15.3c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.86,15.3c0,.25.2.44.44.44h.59c.25,0,.44-.2.44-.44h0c0-.25-.2-.44-.44-.44h-.59c-.25,0-.44.2-.44.44h0Z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.61,
    y: 10.41,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.48,
    y: 10.41,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.35,
    y: 10.41,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.22,
    y: 10.41,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.61,
    y: 13.37,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.48,
    y: 13.37,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.35,
    y: 13.37,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.22,
    y: 13.37,
    width: 2.37,
    height: 2.37,
    rx: 0.65,
    ry: 0.65
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.81,2.34h-16.15v.5s-.28,1.61-1.37,1.61H19.86c-1.08,0-1.37-1.61-1.37-1.61v-.5H2.35c-1.3,0-2.35,1.05-2.35,2.35v38.81c0,1.3,1.05,1.17,2.35,1.17h94.46c1.3,0,2.35.13,2.35-1.17V4.69c0-1.3-1.05-2.35-2.35-2.35ZM95.54,3.72c.57,0,1.04.46,1.04,1.04s-.46,1.04-1.04,1.04-1.04-.46-1.04-1.04.46-1.04,1.04-1.04ZM87.94,4.32h5.33c.25,0,.44.2.44.44s-.2.44-.44.44h-5.33c-.24,0-.44-.2-.44-.44s.2-.44.44-.44ZM3.29,4.32h5.92c.24,0,.44.2.44.44s-.2.44-.44.44H3.29c-.25,0-.44-.2-.44-.44s.2-.44.44-.44ZM32.69,40.53c0,.93-.69,1.68-1.53,1.68H4.35c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71ZM32.69,28.29c0,.93-.69,1.68-1.53,1.68H4.35c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71ZM32.69,16.45c0,.93-.69,1.68-1.53,1.68H4.35c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71ZM64.65,40.53c0,.93-.69,1.68-1.53,1.68h-26.81c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71ZM64.65,28.29c0,.93-.69,1.68-1.53,1.68h-26.81c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71ZM64.65,16.45c0,.93-.69,1.68-1.53,1.68h-26.81c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71ZM96.62,40.53c0,.93-.69,1.68-1.53,1.68h-26.81c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71ZM96.62,28.29c0,.93-.69,1.68-1.53,1.68h-26.81c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71ZM96.62,16.45c0,.93-.69,1.68-1.53,1.68h-26.81c-.85,0-1.53-.75-1.53-1.68v-6.71c0-.93.69-1.68,1.53-1.68h26.81c.85,0,1.53.75,1.53,1.68v6.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxe);
export default __webpack_public_path__ + "static/media/oxe.3c59b9771fd2c3440e4520993e568fe2.svg";
export { ForwardRef as ReactComponent };